import { styled } from '@mui/material/styles';
import { TextField, Typography, Paper } from '@mui/material';
import { renderTypographyStyles } from 'mui/base/utils';

export const StyledInput = styled(TextField)(
  ({ theme }) => `
      
   width: 100% !important;
         
   .Mui-error {
     color: ${theme.DS_palette.buttons.error}; 
       & fieldset  {
        border-color:  ${theme.DS_palette.buttons.error} !important;
       }
    }
    
 
    & .MuiOutlinedInput-root {
      &:hover .MuiOutlinedInput-notchedOutline{
        border-color: ${theme.DS_palette.buttons.enabled}; 
      } 
    
       ${renderTypographyStyles(theme.typography.DS_copyMediumRegular)};
       height: 52px;
       
       .MuiInputBase-input[data-com-onepassword-filled="light"], .MuiInputBase-input:autofill {
          border-radius: ${theme.DS_border.radius.highlighted};
       }
        
       & fieldset {
         border-color:  ${theme.DS_palette.border.form};
         border-radius: ${theme.DS_border.radius.highlighted};
         :focus, :hover {
           border-color: ${theme.DS_palette.buttons.enabled};
          } 
          }
        }
        
        
       label.MuiFormLabel-root {
       top: -3px;
          color: ${theme.DS_palette.text.secondary};
          ${renderTypographyStyles(theme.typography.DS_copyMediumRegular)};
            &.Mui-error{
              color: ${theme.DS_palette.buttons.error};
            }
        }
        div {
         margin-bottom: ${theme.DS_spacing(['xl'])};
     
        }
        
      & .MuiFormHelperText-root.Mui-error{
         ${renderTypographyStyles(theme.typography.DS_copySmallRegular)};
        position: absolute;
        top: ${theme.DS_spacing(['xlx'])};
        left: ${theme.DS_spacing(['xs'])};
        margin: 0;
        color: ${theme.DS_palette.buttons.error};
      }
`,
);
export const StyledPhoneInputLabel = styled('label')(
  ({ theme }) => `
  
    width: 100%;
    margin-bottom: ${theme.DS_spacing(['xxs'])};
    .input-error.react-tel-input {
       .form-control, .form-control:focus {
        border-color:  ${theme.DS_palette.buttons.error};
      }
       .special-label {
        color:  ${theme.DS_palette.buttons.error};

        padding-left: 8px ;
      }
    }
    
    #phoneNumber{
      color: ${theme.DS_palette.text.secondary};
      &:focus {
            color: ${theme.DS_palette.primary.black};
      }
    }
    .react-tel-input {
       margin-bottom: ${theme.spacing(['xs'])};
       
       &:hover:not(.input-error) .form-control{
       border-color: ${theme.DS_palette.buttons.enabled};
       }
       
      .form-control {
        font-size: 16px;
        ${theme.breakpoints.up('lg')} {
          font-size: 18px;
        }
        height: 52px;
        border: 1px solid ${theme.DS_palette.border.form};
        border-radius: ${theme.DS_border.radius.highlighted};
        width: 100%;
        outline: none;
        padding: 18.5px 14px 18.5px 58px;
        transition: box-shadow ease 0.25s, border-color ease 0.25s;
          &:focus {
            border-color: ${theme.DS_palette.buttons.enabled};
            border-width: 2px;
            & + div:before {
              color: ${theme.DS_palette.buttons.enabled};
              border-width: 2px;
            }
          }
      }
      
      .flag-dropdown {
        position: absolute;
        top: 0;
        bottom: 0;
        padding: 0;
        border: none;
        background-color: transparent;
        &:hover,
        &:focus {
          cursor: pointer;
          background-color: transparent;
        }
        &.open {
          background-color: transparent;
          z-index: 1050;
        }
      }
    
      input[disabled] {
        & + .flag-dropdown {
          &:hover {
            cursor: default;
            border-color: #cacaca;
            .selected-flag {
              background-color: transparent;
            }
          }
        }
      }
      .selected-flag {
         &:hover, &:active {
           background: transparent;
        }   
        &:focus {
           background: transparent;
          .arrow {
            border-left-width: 4px;
            border-right-width: 4px;
          }
        }
        .flag {
          position: absolute;
          top: 50%;
          left:16px;
          transform: scale(1.3);
        }
      }
     .country-list {
        outline: none;
        z-index: 1;
        list-style: none;
        position: absolute;
        background-color: white;
        max-width: 335px;
        max-height: 220px;
        overflow-y: scroll;
        border: 1px solid ${theme.DS_palette.border.form};
        border-radius: ${theme.DS_border.radius.highlighted};
        .flag {
          display: inline-block;
          position: absolute;
          left: 30px;
          top: 8px;
        }
        .country {
          position: relative;
          padding: 12px 9px 13px 46px;
          .dial-code {
            color: ${theme.DS_palette.primary.black};
             ${renderTypographyStyles(theme.typography.DS_copyMediumRegular)};
          }
          &:hover {
            background-color: ${theme.DS_palette.border.form};
          }
          &.highlight {
            background-color: #f1f1f1;
          }
       }
      .flag {
        margin-right: 20px;
        margin-top: 2px;
        transform: scale(1.3);
      }
      .country-name {
        margin-right: 26px;
        margin-left: 26px;
        ${renderTypographyStyles(theme.typography.DS_copyMediumRegular)};
      }
      .search {
        z-index: 2;
        position: sticky;
        top: 0;
        background-color: ${theme.DS_palette.primary.white};
        padding: ${theme.spacing(['xs'])};
      }
      .search-emoji {
        display: none;
      }
      .search-box {
        border: 1px solid ${theme.DS_palette.border.form};
        border-radius: ${theme.DS_border.radius.highlighted};
        ${renderTypographyStyles(theme.typography.DS_copyMediumRegular)};
     
        margin-left: 6px;
        padding: 6px 8px 5px;
        outline: none;
        &:hover {
          border-color: #505050;
        }
      }
      .no-entries-message {
        padding: 7px 10px 11px;
        opacity: 0.7;
      }
    }
 
    .special-label {
      color: ${theme.DS_palette.text.secondary};
      position: absolute;
      z-index: 1;
      top: -7px;
      left: 8px;
      display: block;
      background: white;
      padding: 0 5px;
      font-size: 12px;
      white-space: nowrap;
    }
  }
  .react-tel-input .flag-dropdown.open .selected-flag {
  background: transparent;
  border-radius: 3px 0 0 0;
}
`,
);

export const StyledErrorWrapper = styled('div')`
  position: relative;
  text-align: left;
  width: 100%;
`;

export const Error = styled(Typography)(
  ({ theme }) => `
  position: absolute;
  top: -${theme.DS_spacing(['xs'])};
  left: ${theme.DS_spacing(['xxsx'])};
  color: ${theme.DS_palette.buttons.error};
  &.error-checkbox-msg{
   top: 34px;
   left: 34px;
  }

`,
);
export const StyledCheckboxWrapper = styled('label')(
  ({ theme }) => `
  position: relative;
  display: flex;
  align-items: flex-start;
  width: 100%;

  margin-bottom: ${theme.DS_spacing(['xs'])};
  div{
    & .MuiCheckbox-root.checkbox-error{
     color: ${theme.DS_palette.buttons.error};
   }
    &.Mui-checked {
      svg{
        fill:  ${theme.DS_palette.buttons.enabled};
      }
    }
  }
`,
);

export const StyledDisclaimer = styled('div')(
  ({ theme }) => `
   ${renderTypographyStyles(theme.typography.DS_copyMediumRegular)};
`,
);

export const StyledDisclaimerWrapper = styled('span')(
  ({ theme }) => `
  padding-top: ${theme.DS_spacing(['xxs'])};
  width: 100%;
`,
);

export const StyledSelectLabel = styled('label')(
  ({ theme }) => `
  margin-top: ${theme.DS_spacing(['xxs'])};
  width: 100%;
  position: relative;
`,
);

export const IconImg = styled('img')`
  position: absolute;
  width: 16px;
  height: 16px;
  margin-left: -31px;
  margin-top: 19px;
`;

export const LoaderWrapper = styled('div')(
  ({ theme }) => `
  position: absolute;
  top: 45px;
  height: 80px;
  width: 100%;
  background: #fff;
  border: 1px solid ${theme.DS_palette.background.lightGrey};
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.05);
  z-index: 2;

  div {
    top: 35px;
  }
`,
);

export const StyleMenuContainer = styled(Paper)(
  ({ theme }) => `
  margin-top: -${theme.DS_spacing(['xs'])};
  border: 1px solid ${theme.DS_palette.border.form};
  width: 100%;
  border-radius: ${theme.DS_border.radius.highlighted};
 
   ul{
    max-height: 215px;
    margin: 2px;
    overflow-y: scroll;
   }

  li {
     padding-left: ${theme.spacing(['xxs'])};
    &:hover {
      background-color: ${theme.palette.background.gray.light};
    }
  }
`,
);

export const SelectSubtitle = styled('span')(
  ({ theme }) => `
  color: ${theme.DS_palette.buttons.error};
  padding-left: 16px;

   ${theme.breakpoints.up('tablet')} {
       margin-top: 0;
       font-size: 0.94em;
    }

`,
);

/* survey button styles */

const dynamicButtonSurveyStyles = ({ theme, isSelected }) =>
  isSelected &&
  `
    background-color: #fff;
    border-color: ${theme.palette.primary.action}
  `;

const dynamicButtonSurveyMediaStyles = ({ theme, hasMedia }) =>
  hasMedia &&
  `
    display: flex;
    justify-content:center;
    align-items: center;
    height: 100px;
    .gatsby-image-wrapper {
      width: 100%;
      flex: 1;  
      > picture > img {
         padding-left: ${theme.spacing(['md'])};
      }
    
    }
  `;

const dynamicButtonSurveyMediaInlineStyles = ({ hasMedia, isInline }) =>
  hasMedia &&
  isInline &&
  `
    flex-direction: column;
    height: auto;

    .gatsby-image-wrapper {
      margin-bottom: 36px;
        > picture > img {
         padding-left: 0;
      }
    }
  `;

export const StyledButtonSurveyWrapper = styled('label')(
  ({ theme, hasMedia, isInline, isSelected }) => `
  background: ${theme.palette.background.gray.light};
  border: 2px solid ${theme.palette.background.gray.dark};
  border-radius: ${theme.DS_border.radius.highlighted};
  cursor: pointer;
  padding: 15px 5px;
  text-align: center;
  transition: border-color 0.25s ease;
  height: 55px;
  position: relative;

  :hover {
    border-color: ${theme.palette.primary.action};
  }

  ${dynamicButtonSurveyStyles({ theme, isSelected })};
  ${dynamicButtonSurveyMediaStyles({ theme, hasMedia })};
  ${dynamicButtonSurveyMediaInlineStyles({ hasMedia, isInline })};
`,
);

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
export const HiddenButtonSurvey = styled('input')`
  opacity: 0;
  position: absolute;
`;

const dynamicButtonSurveyLabelStyles = ({ theme, hasMedia, isInline }) =>
  hasMedia && !isInline
    ? `
    flex: 1;
    text-align: left;
    padding-left: ${theme.spacing(['lg'])};
  `
    : !hasMedia && !isInline
    ? ` 
     position: absolute;
     text-align:center;
     width: 100%;
     top: 15px;
     left:0;
  `
    : `position:relative;
    `;

export const StyledButtonSurveyLabel = styled('span')(
  ({ theme, hasMedia, isInline }) => `
  font-size: 1.25rem;
  ${dynamicButtonSurveyLabelStyles({ theme, hasMedia, isInline })};
  
`,
);
